import {
  pgTable,
  uuid,
  text,
  timestamp,
  integer,
  boolean,
  jsonb,
  index,
} from "drizzle-orm/pg-core";

const tz = { withTimezone: true } as const;

// ---------------------------------------------------------------------------
// Pipeline Definitions — Tenant-customizable deal pipelines (C.11)
// ---------------------------------------------------------------------------
// Replaces config-driven pipelines with DB-driven. Tenants can create
// multiple pipelines with custom stages, colors, required fields, auto-tasks,
// and stage hooks (onEnterActions/onExitActions for future automation).
//
// Fallback: if no DB pipelines exist, pipeline-service returns DEFAULT_PIPELINE.

export const pipelineDefinitions = pgTable("pipeline_definitions", {
  id: uuid("id").primaryKey().defaultRandom(),
  tenantId: uuid("tenant_id").notNull(),
  name: text("name").notNull(),
  isDefault: boolean("is_default").notNull().default(false),
  createdAt: timestamp("created_at", tz).notNull().defaultNow(),
  updatedAt: timestamp("updated_at", tz).notNull().defaultNow(),
}, (table) => [
  index("idx_pipeline_def_tenant").on(table.tenantId),
]);

export const pipelineStages = pgTable("pipeline_stages", {
  id: uuid("id").primaryKey().defaultRandom(),
  pipelineId: uuid("pipeline_id").notNull().references(() => pipelineDefinitions.id, { onDelete: "cascade" }),
  tenantId: uuid("tenant_id").notNull(),
  stageId: text("stage_id").notNull(), // Slug: "new", "contacted", "won"
  name: text("name").notNull(),
  displayOrder: integer("display_order").notNull().default(0),
  color: text("color").notNull().default("#6B7280"),
  isWinStage: boolean("is_win_stage").notNull().default(false),
  isLossStage: boolean("is_loss_stage").notNull().default(false),
  maxDays: integer("max_days"), // Nullable = no time limit
  // S.4: Default win probability for deals entering this stage
  defaultWinProbability: integer("default_win_probability"), // 10% at "New", 90% at "Contract"
  requiredFields: jsonb("required_fields").$type<string[]>().notNull().default([]),
  autoTasks: jsonb("auto_tasks").$type<Record<string, unknown>[]>().notNull().default([]),
  // Stage hooks for future automation (C.11 schema-only)
  onEnterActions: jsonb("on_enter_actions").$type<Record<string, unknown>[]>().notNull().default([]),
  onExitActions: jsonb("on_exit_actions").$type<Record<string, unknown>[]>().notNull().default([]),
  createdAt: timestamp("created_at", tz).notNull().defaultNow(),
  updatedAt: timestamp("updated_at", tz).notNull().defaultNow(),
}, (table) => [
  index("idx_pipeline_stage_pipeline").on(table.pipelineId, table.displayOrder),
  index("idx_pipeline_stage_tenant").on(table.tenantId),
]);
